var map = {
	"./V.svg": "9ab0",
	"./apple-wallet-icon.svg": "a2de",
	"./azure-logo.png": "f6e0",
	"./brands/bitbucket.png": "16ae",
	"./brands/dribbble.png": "ddfc",
	"./brands/dropbox.png": "aee3",
	"./brands/github.png": "866f",
	"./brands/mail_chimp.png": "8f44",
	"./brands/slack.png": "4f43",
	"./check-email.svg": "c4a0",
	"./check-phone-msg.svg": "e558",
	"./clients/1.png": "19e9",
	"./clients/2.png": "fd18",
	"./clients/3.png": "2a89",
	"./clients/4.png": "2f52",
	"./clients/5.png": "778a",
	"./clients/6.png": "9503",
	"./close-icon.svg": "9b7f",
	"./companies/img-1.png": "0bcf",
	"./companies/img-2.png": "551f",
	"./companies/img-3.png": "3c22",
	"./companies/img-4.png": "502e",
	"./companies/img-5.png": "df2d",
	"./companies/img-6.png": "f035",
	"./crypto/bg-ico-hero.jpg": "c64b",
	"./crypto/blog/img-1.jpg": "0ee8",
	"./crypto/blog/img-2.jpg": "dd00",
	"./crypto/blog/img-3.jpg": "0c85",
	"./crypto/features-img/img-1.png": "201e",
	"./crypto/features-img/img-2.png": "2d8a",
	"./error-img.png": "7f6b",
	"./favicon.ico": "fbec",
	"./flags/arabic.png": "75842",
	"./flags/chaina.png": "326d",
	"./flags/french.jpg": "570f",
	"./flags/germany.jpg": "8a5d",
	"./flags/italy.jpg": "12db",
	"./flags/russia.jpg": "de9d",
	"./flags/spain.jpg": "b084",
	"./flags/us.jpg": "b140",
	"./googlepay-icon.svg": "e5ac",
	"./img/azure.png": "ebed",
	"./img/google.png": "d237",
	"./img/paxton.png": "f987",
	"./img/wonde.png": "73862",
	"./layouts/layout-1.jpg": "752a",
	"./layouts/layout-2.jpg": "9d24",
	"./layouts/layout-3.jpg": "db58",
	"./leaflet/marker-icon.png": "2bf7",
	"./loading.gif": "12ae",
	"./logo-dark.png": "59da",
	"./logo-lg.svg": "db91",
	"./logo-light.png": "ea27",
	"./logo-light.svg": "e91d",
	"./logo-pdf.png": "9a07",
	"./logo.svg": "e347",
	"./logo/visipoint logo.jpg": "c3c3",
	"./logo/visipoint logo.png": "f363",
	"./logo/visipoint logo.svg": "45ad",
	"./logo/visipoint logo@2x.jpg": "a65f",
	"./logo/visipoint logo@2x.png": "1bf7",
	"./logo2.svg": "4c46",
	"./maintenance.png": "d6f9",
	"./megamenu-img.png": "2411",
	"./no-profile.png": "c905",
	"./product/img-1.png": "c080",
	"./product/img-2.png": "2a0c",
	"./product/img-3.png": "8416",
	"./product/img-4.png": "516e",
	"./product/img-5.png": "2acb",
	"./product/img-6.png": "8b3b",
	"./product/img-7.png": "cafd",
	"./product/img-8.png": "7217",
	"./profile-img.png": "7006",
	"./profile-img2.png": "2449",
	"./sad-face-icon.svg": "7a34",
	"./small/img-1.jpg": "19b7",
	"./small/img-2.jpg": "88e3",
	"./small/img-3.jpg": "b168",
	"./small/img-4.jpg": "134b",
	"./small/img-5.jpg": "bb17",
	"./small/img-6.jpg": "3f9c",
	"./small/img-7.jpg": "cf63",
	"./smaller-than.svg": "0ebb",
	"./spain-country-flag-icon.png": "8366",
	"./users/anonymous.png": "7638",
	"./users/avatar-1.jpg": "c3eb",
	"./users/avatar-2.jpg": "95f5",
	"./users/avatar-3.jpg": "61ae",
	"./users/avatar-4.jpg": "1f62",
	"./users/avatar-5.jpg": "a8a4",
	"./users/avatar-6.jpg": "d03b",
	"./users/avatar-7.jpg": "cd5e",
	"./users/avatar-8.jpg": "9f20",
	"./vectors.svg": "86cd",
	"./verification-img.png": "a23f",
	"./visipoint-logo.svg": "e8f8",
	"./visipoint.png": "fe74",
	"./visipointlogo@2x.png": "1819"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";